import { GuideHint } from 'components/admin/visual/GuideHint';
import { EColors2, EFonts, EVariables } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    title: string;
    className?: string;
    hint?: string;
}

export const GuideTitle = (props: Props): JSX.Element => {
    return (
        <S_GuideTitle className={props.className}>
            <S_Title>{props.title}</S_Title>
            {props.hint && <GuideHint text={props.hint} />}
        </S_GuideTitle>
    );
};

const S_GuideTitle = styled.div`
    display: flex;
    flex-direction: row;
    text-align: center;
    align-items: center;
    position: relative;
    text-align: left;
`;

const S_Title = styled.div`
    color: ${EColors2.DARK};
    font-family: ${EFonts.Bold};
    font-size: 19px;
    letter-spacing: ${EVariables.Spacing2};
`;
